import { useContext } from 'react';

import { ToastStateContext } from './context';
import { type ToastState } from './types';

function useToastState(): ToastState {
    const state = useContext(ToastStateContext);

    return state;
}

export { useToastState };
